import {
  GET_SCHOOLYEARS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/reports/schoolyears_list/get'

import { api } from 'app/api'
import { OrgId } from 'app/common/types/id'

export const getSchoolYear = async (params: { orgId: OrgId }, signal?: AbortSignal) => {
  const res = await api.request(GET_SCHOOLYEARS, {
    additionalAxiosOptions: {
      signal,
    },
    error: 'Не удалось получить данные учебных лет',
    params,
    convertions: {
      convertParams,
      convertResult,
    },
  })

  return res
}
